module.exports = __webpack_public_path__ + "static/media/VestasSans-Thin.ab5c8839.svg";